import {Directive, Output, EventEmitter, HostListener} from '@angular/core';


@Directive({
  selector: '[appDragNDropFiles]'
})
export class DragNDropFilesDirective {
  @Output() fileDropped = new EventEmitter();

  constructor() { }

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if(files.length){
      this.fileDropped.emit(files);
    }

  }

}
